import { useRef } from 'react';

// A ref, not state: every call that lands before React re-renders would read the old state value.
export const useOneAtATime = <TArgs extends unknown[]>(run: (...args: TArgs) => Promise<void>) => {
  const isRunningRef = useRef(false);

  return async (...args: TArgs) => {
    if (isRunningRef.current) return;
    isRunningRef.current = true;
    try {
      await run(...args);
    } finally {
      isRunningRef.current = false;
    }
  };
};
